/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * Comparison operators for pricing tier conditions
 */
export type PricingTierOperator = "gt" | "gte" | "lt" | "lte" | "eq" | "neq";
export const PricingTierOperator = {
  Gt: "gt",
  Gte: "gte",
  Lt: "lt",
  Lte: "lte",
  Eq: "eq",
  Neq: "neq",
} as const;
